import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { DispatchDatahubEvents } from '../../components/pageCard/actions/dispatchDatahubEvents';
import { ModuleCacheUpdater, PageCacheUpdater } from '../../helpers';
import { useIsExtraModule } from 'src/modules/contentList/hooks/useIsExtraModule';
import { BulkActionService } from 'src/modules/contentList/services';
import { Toast } from 'src/shared/components/toast';
export function useDeletePage(page) {
    const { t } = useTranslation();
    const isExtraModule = useIsExtraModule();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const deleteMutation = useMutation({
        mutationFn: BulkActionService.delete,
        onSuccess: () => {
            Toast.show({ type: 'success', message: t('content_list.delete_page.success') });
            setShowDeleteConfirmation(false);
            PageCacheUpdater.delete([page.id], page.moduleId);
            ModuleCacheUpdater.updateTotalPages({
                moduleId: page.moduleId,
                isExtraModule,
                totalPages: (totalPages) => totalPages - 1
            });
        },
        onError: () => {
            Toast.show({ type: 'danger', message: t('content_list.delete_page.error') });
        }
    });
    function handleShowConfirmation(pageType) {
        setShowDeleteConfirmation(true);
        DispatchDatahubEvents.clickContentPageDelete(pageType);
    }
    function handleCloseConfirmation() {
        setShowDeleteConfirmation(false);
    }
    return {
        deleteMutation,
        showDeleteConfirmation,
        handleCloseConfirmation,
        handleShowConfirmation
    };
}
